import React from "react";

const SummaryCard2 = ({ title, value, color = "blue" }) => {
  return (
    <div className={`summary-card ${color}`} style={{ height: "100px" }}>
      <h4 className="sc-title">{title}</h4>
      <span className="bg-circle" style={{ backgroundColor: color }}></span>
      <h2 className="sc-value">{value}</h2>
    </div>
  );
};

export default SummaryCard2;
